// ตัวอ่านบาร์โค้ด (ZXing-C++ ผ่าน WebAssembly) — Safari บน iOS ยังไม่มี BarcodeDetector
// ที่ใช้งานได้จริง เลยต้องอ่านเองจาก canvas
//
// ⚠️ ถ้าไม่เรียก prepareZXingModule ตัว lib จะไปโหลด .wasm จาก jsDelivr (CDN นอก)
// ซึ่งใช้ได้ตอน dev แล้วมาพังเงียบ ๆ ตอนเน็ตร้าน/CDN โดนบล็อก — เลยล็อกให้ชี้ไฟล์
// ที่ esbuild ปล่อยไว้ที่ origin เราเอง (ชื่อไฟล์มี content hash = ล็อกเวอร์ชันให้ตรงกับ JS อัตโนมัติ)
import wasmUrl from 'zxing-wasm/reader/zxing_reader.wasm';
import { prepareZXingModule, readBarcodes } from 'zxing-wasm/reader';

let warm = null;

/** เรียกตอนเปิดหน้าสแกน (ไม่ใช่ตอนบูตแอป) — resolve เมื่อ wasm พร้อมใช้ */
export function warmUpScanner() {
  if (!warm) {
    warm = prepareZXingModule({
      overrides: { locateFile: (path, prefix) => (path.endsWith('.wasm') ? wasmUrl : prefix + path) },
      fireImmediately: true,
    });
  }
  return warm;
}

// ลูปสด: ค่า default ของ zxing (ทุก format + tryHarder/tryRotate/tryInvert) คือโหมด
// "หาให้เจอทุกอย่างทุกมุม" — ช้าและกินแบตมาก ในลูปเลยตัดเหลือเท่าที่ป้ายสินค้าใช้จริง
// ชื่อ format ใช้ตัวสะกดตาม BARCODE_FORMATS ของ zxing (EAN13 ไม่ใช่ EAN-13)
// tryRotate เปิดไว้ = อ่านป้ายที่วางตะแคงได้โดยไม่ต้องเอียงเครื่อง
// (วัดจริง 30 ก.ค.: กรอบจัตุรัส 1080px หมุนได้ 3.5ms vs ไม่หมุน 2.9ms — แลกคุ้มมาก
//  ของเดิมแถบนอน+ไม่หมุน อ่านบาร์โค้ดตะแคง 90° "ไม่ได้เลย")
export const LIVE_OPTS = {
  formats: ['EAN13', 'EAN8', 'UPCA', 'UPCE', 'Code128', 'Code39', 'ITF'],
  tryHarder: false,
  tryRotate: true,
  tryInvert: false,
  tryDownscale: false,
  maxNumberOfSymbols: 1,
};

// รอบหนัก: ยิงเมื่อลูปเร็วหาไม่เจอมาสักพัก (ป้ายเอียง/ยับ/สะท้อน)
export const DEEP_OPTS = { ...LIVE_OPTS, tryHarder: true, tryRotate: true, tryInvert: true, tryDownscale: true };

// symbology ที่ไม่มี check digit ในตัว → ต้องอ่านตรงกัน 2 ครั้งถึงจะเชื่อ
// (เทียบแบบไม่สนช่องว่าง/ขีด เผื่อ zxing คืน "Code 39" แทน "Code39")
const WEAK = ['itf', 'code39'];
export const isWeakFormat = f => WEAK.includes(String(f || '').toLowerCase().replace(/[\s-]/g, ''));

export { readBarcodes };
